var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 37,
    viewBox: "0 0 43 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.06055,
    y: 1.40204,
    width: 41,
    height: 35,
    rx: 2.3,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.06055,
    y: 1.40204,
    width: 41,
    height: 35,
    rx: 2.3,
    stroke: "#999999"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0225 6.72066H31.7168C32.05 6.72066 32.3216 6.97615 32.3216 7.29189C32.3216 7.45218 32.2516 7.59694 32.1395 7.70087L29.766 9.943C31.5091 11.7373 32.6672 13.9659 33.128 16.3071C33.6134 18.7756 33.3254 21.3702 32.1304 23.7184C30.9631 26.013 29.0348 27.7129 26.6727 28.7398C24.2735 29.7822 21.4268 30.127 18.4784 29.6909C18.1503 29.6433 17.9251 29.3518 17.9755 29.0419C18.0063 28.8564 18.1287 28.7048 18.2933 28.6242L18.2922 28.6222C18.3272 28.6047 30.2793 22.8441 23.8323 15.5474L21.4505 17.7973C21.2139 18.0207 20.8324 18.0207 20.5959 17.7973C20.4786 17.6866 20.419 17.5399 20.419 17.3941V7.29194C20.419 6.97622 20.6882 6.72066 21.0225 6.72066ZM10.3723 24.8219H15.7931C16.1263 24.8219 16.3978 25.0774 16.3978 25.3931V30.5137C16.3978 30.8294 16.1273 31.0849 15.7931 31.0849H10.3723C10.0391 31.0849 9.76758 30.8295 9.76758 30.5137V25.3931C9.76758 25.0784 10.038 24.8219 10.3723 24.8219ZM10.3723 15.7706H15.7931C16.1263 15.7706 16.3978 16.0261 16.3978 16.3419V21.4625C16.3978 21.7772 16.1273 22.0337 15.7931 22.0337H10.3723C10.0391 22.0337 9.76758 21.7782 9.76758 21.4625V16.3419C9.76758 16.0271 10.038 15.7706 10.3723 15.7706ZM10.3723 6.71942H15.7931C16.1263 6.71942 16.3978 6.9749 16.3978 7.29065V12.4113C16.3978 12.726 16.1273 12.9825 15.7931 12.9825H10.3723C10.0391 12.9825 9.76758 12.727 9.76758 12.4113V7.29065C9.76758 6.97493 10.038 6.71942 10.3723 6.71942Z",
    fill: "black",
    fillOpacity: 0.57
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.62dbc2a7b971f16441933fdec6fbd268.svg";
export { ForwardRef as ReactComponent };